import React from 'react';
import { cx } from '../ui/cx';

function BottomTabBar({ tabs, activeTab, onTabChange }) {
  return (
    <nav className="shrink-0 bg-white border-t border-border relative">
      <div
        className="grid"
        style={{ gridTemplateColumns: `repeat(${tabs.length}, minmax(0, 1fr))` }}
      >
        {tabs.map((tab) => {
          const active = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={cx(
                'relative flex flex-col items-center gap-1 py-2.5 cursor-pointer',
                'transition-all duration-150',
                'focus:outline-none focus:ring-2 focus:ring-primary/40 focus:ring-inset',
                active
                  ? 'text-primary'
                  : 'text-body/40 hover:text-body hover:bg-surface'
              )}
            >
              {active && (
                <span className="absolute top-0 left-1/2 -translate-x-1/2 w-10 h-[2px] bg-primary rounded-full" />
              )}
              {typeof tab.icon === 'string' ? (
                <span className="text-lg leading-none">{tab.icon}</span>
              ) : (
                tab.icon
              )}
              <span className={cx('text-11 tracking-wide', active ? 'font-semibold' : 'font-medium')}>{tab.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}

export default BottomTabBar;
